//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import { getIsInfluencersDiscoveryEnabled } from '@influencers/selectors/getInfluencersLists';
import { NavDropdownMenuItem } from '@legacy-components/nav3/navigation-menus/NavDropdownMenuItem';
import { NavMenuItem } from '@legacy-components/nav3/navigation-menus/NavMenuItem';
import { NAV_MENU_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';
import { CreatorsMenu } from '@legacy-components/nav3/navigation-menus/dropdown-menus/CreatorsMenu';
import { getIsCreatorCommunityEnabled } from '@legacy-components/nav3/navigation-menus/selectors/getIsCreatorCommunityEnabled';

import { NavGroup } from 'app/initialization/routing/stateHelpers';

interface Props {
  setIsMenuOpen: (isMenuOpen: boolean) => void;
}

export const CreatorsNav = ({ setIsMenuOpen }: Props) => {
  const isInfluencersDiscoveryEnabled = useSelector(
    getIsInfluencersDiscoveryEnabled,
  );
  const isCreatorCommunityEnabled = useSelector(getIsCreatorCommunityEnabled);

  const isCreatorsEnabled =
    isInfluencersDiscoveryEnabled || isCreatorCommunityEnabled;

  const isOnlyCreatorsVisible =
    isInfluencersDiscoveryEnabled && !isCreatorCommunityEnabled;

  const isOnlyCommunityVisible =
    !isInfluencersDiscoveryEnabled && isCreatorCommunityEnabled;

  if (!isCreatorsEnabled) {
    return null;
  }

  return isOnlyCreatorsVisible ? (
    <NavMenuItem
      activeNavGroup={NavGroup.INFLUENCERS}
      state='influencers'
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.CREATORS_NAV}
    >
      Creators
    </NavMenuItem>
  ) : isOnlyCommunityVisible ? (
    <NavMenuItem
      activeNavGroup={NavGroup.COMMUNITY}
      state='community'
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.COMMUNITY_NAV}
    >
      Community
    </NavMenuItem>
  ) : (
    <NavDropdownMenuItem
      activeNavGroup={[NavGroup.INFLUENCERS, NavGroup.COMMUNITY]}
      content={<CreatorsMenu />}
      setIsMenuOpen={setIsMenuOpen}
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.CREATORS_NAV}
    >
      Creators
    </NavDropdownMenuItem>
  );
};
